export default __webpack_public_path__ + "static/media/plain-sticker-p.a4d47fd2.png";